/**
 * @flow
 * @relayHash 0f3d88ee33f42938b1c5d4e37a162d72
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ContentIssueTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type ContentIssueTable_RefetchQueryVariables = {|
  offset?: ?number,
  limit?: ?number,
  typeFilters?: ?$ReadOnlyArray<?string>,
  lenOrder?: ?number,
  url?: ?TextFilters,
  host: string,
|};
export type ContentIssueTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: ContentIssueTable_project$ref
  |}
|};
export type ContentIssueTable_RefetchQuery = {|
  variables: ContentIssueTable_RefetchQueryVariables,
  response: ContentIssueTable_RefetchQueryResponse,
|};
*/


/*
query ContentIssueTable_RefetchQuery(
  $offset: Int
  $limit: Int
  $typeFilters: [String]
  $lenOrder: Int
  $url: TextFilters
  $host: String!
) {
  project(host: $host) {
    ...ContentIssueTable_project_2XtMJF
    id
  }
}

fragment ContentIssueTable_project_2XtMJF on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesContentIssues(url: $url) {
          type
          severity
          count
        }
        contentIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder) {
          count
          edges {
            node {
              ...ContentIssueRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment ContentIssueRow_issue on ContentIssue {
  id
  type
  severity
  content_len_wrd
  urls
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "typeFilters",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "lenOrder",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ContentIssueTable_RefetchQuery",
  "id": null,
  "text": "query ContentIssueTable_RefetchQuery(\n  $offset: Int\n  $limit: Int\n  $typeFilters: [String]\n  $lenOrder: Int\n  $url: TextFilters\n  $host: String!\n) {\n  project(host: $host) {\n    ...ContentIssueTable_project_2XtMJF\n    id\n  }\n}\n\nfragment ContentIssueTable_project_2XtMJF on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesContentIssues(url: $url) {\n          type\n          severity\n          count\n        }\n        contentIssues(offset: $offset, limit: $limit, typeFilters: $typeFilters, url: $url, lenOrder: $lenOrder) {\n          count\n          edges {\n            node {\n              ...ContentIssueRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ContentIssueRow_issue on ContentIssue {\n  id\n  type\n  severity\n  content_len_wrd\n  urls\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ContentIssueTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentIssueTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "lenOrder",
                "variableName": "lenOrder",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "typeFilters",
                "variableName": "typeFilters",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ContentIssueTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesContentIssues",
                        "storageKey": null,
                        "args": [
                          v2
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v3,
                          v4,
                          v5
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contentIssues",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "lenOrder",
                            "variableName": "lenOrder",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "typeFilters",
                            "variableName": "typeFilters",
                            "type": "[String]"
                          },
                          v2
                        ],
                        "concreteType": "ContentIssuesConnection",
                        "plural": false,
                        "selections": [
                          v5,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContentIssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ContentIssue",
                                "plural": false,
                                "selections": [
                                  v6,
                                  v3,
                                  v4,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "content_len_wrd",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urls",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v6
                    ]
                  }
                ]
              }
            ]
          },
          v6
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1f6b53e409400a43d1d866520ca56674';
module.exports = node;
